import { appendReduxParts } from "infrastructure/store";

import TranslationMessagesManager from "./TranslationMessages";
import { translationMessagesManagerSaga } from "./TranslationMessages.saga";
import { translationMessages } from "./TranslationMessages.slice";
import { translationUploadSaga } from "./upload/TranslationUpload.saga";
import { translationUploadManager } from "./upload/TranslationUpload.slice";

export { TranslationMessagesManager };
export * from "./TranslationMessages.slice";

appendReduxParts(
  [
    {
      reducerName: translationMessages.name,
      reducer: translationMessages.reducer
    },
    {
      reducerName: translationUploadManager.name,
      reducer: translationUploadManager.reducer
    }
  ],
  [translationMessagesManagerSaga(), translationUploadSaga()]
);
